"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _ThemeHelper = require("../Utilities/ThemeHelper");

var styles = (0, _ThemeHelper.createStyles)(function (theme) {
  return {
    root: {
      // SkeletonTheme renders a div in v2
      // Replace with custom span wrapper
      // https://github.com/dvtng/react-loading-skeleton/issues/46
      "& .react-loading-skeleton": {
        backgroundColor: function backgroundColor(props) {
          return props.color;
        },
        backgroundImage: function backgroundImage(props) {
          return "linear-gradient(\n\t\t\t\t\t90deg,\n\t\t\t\t\t".concat(props.color, ",\n\t\t\t\t\t").concat(props.disableAnimation ? "transparent" : "rgba(0,0,0,.10)", ",\n\t\t\t\t\t").concat(props.color, "\n\t\t\t\t)");
        }
      }
    },
    disableAnimation: {
      "& span[style]": {
        animation: "none !important",
        backgroundImage: "none"
      }
    }
  };
});
exports.styles = styles;